const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class AcademyView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.settings =
		{
			url: '',
		};
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		this.pict.HeadlightPanels.rightPanelCustomWidth(40);
		this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		return super.onAfterRender(pRenderable);
	}

	/**
	 * This is a test
	 */
	openWithURL(url)
	{
		this.settings.url = url;
		this.pict.HeadlightPanels.leftPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.leftPanelHide();
		this.pict.views.HeadlightPanels.handlePanelToggle('AcademyView', 'open');
	}

	resetAndClose()
	{
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelResetCustomWidth();
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
	}

	toggleWidth()
	{
		const toggleEl = this.pict.ContentAssignment.getElement('#split-toggle-icon')?.[0];
		const animate = (el)=>
		{
			el.classList.add('fa-flip');
			setTimeout(()=>
			{
				el.classList.remove('fa-flip');
			}, 500);
		};
		if (toggleEl?.classList?.contains('fa-flip-horizontal'))
		{
			animate(toggleEl);
			toggleEl.classList.remove('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(60);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		}
		else
		{
			animate(toggleEl);
			toggleEl.classList.add('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(40);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		}
	}
}

module.exports = AcademyView;

module.exports.default_configuration =
{
	ViewIdentifier: 'AcademyView',
	DefaultRenderable: 'AcademyView',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'AcademyView-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-AcademyViewPanel" class="panel is-active">
				<p id="HeadlightPanels-AcademyViewPanel-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-left hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.AcademyView.resetAndClose()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button mr-2" class="is-pulled-right" aria-label="expand" title="Resize content" onclick="_Pict.views.AcademyView.toggleWidth()">
						<span class="icon">
							<i class="fas fa-fw fa-table-layout fa-flip-horizontal" aria-hidden="true" id="split-toggle-icon"></i>
						</span>
					</button>
					<span class="icon ml-5">
						<i id="HeadlightPanels-AcademyView-Header-Icon" class="fas fa-fw fa-graduation-cap" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-AcademyView-Header-Title" class="mr-3">Academy</span>
				</p>
				<div id="HeadlightPanels-AcademyView-Content">
					{~T:AcademyView-Content:Pict.views.AcademyView.settings~}
				</div>
			</article>`,
		},
		{
			Hash: 'AcademyView-Content',
			Template: /*html*/`
			<iframe class="has-background-text-40" style="width: 100%; height: 80vh;" src="{~D:Record.url~}" />`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'AcademyView',
			TemplateHash: 'AcademyView-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'AcademyView-Content',
			TemplateHash: 'AcademyView-Content',
			DestinationAddress: '#HeadlightPanels-AcademyView-Content',
			RenderType: 'replace',
		},
	],
};
